import { apiSlice } from "./apiSlice";
export const riskDashboardSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getRiskKpis: builder.query({
            query: (projectId) => ({
                url: `ProjectRisk/project/${projectId}/kpis`,
                // params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            // providesTags: ["AllActionTracker"],
        }),
        getRiskSeveritySummary: builder.query({
            query: (projectId) => ({
                url: `ProjectRisk/project/${projectId}/severity-summary`,
                // params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            // providesTags: ["AllActionTracker"],
        }),
        getRiskCategorySummary: builder.query({
            query: (projectId) => ({
                url: `ProjectRisk/project/${projectId}/category-summary`,
                // params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            // providesTags: ["AllActionTracker"],
        }),
        getRiskOwnerSummary: builder.query({
            query: (projectId) => ({
                url: `ProjectRisk/project/${projectId}/owner-summary`,
                // params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            // providesTags: ["AllActionTracker"],
        }),
        getRiskTrend: builder.query({
            query: (projectId) => ({
                url: `ProjectRisk/project/${projectId}/risk-performance-trend`,
                // params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            // providesTags: ["AllActionTracker"],
        }),
        getRiskHeatMap: builder.query({
            query: (projectId) => ({
                url: `ProjectRisk/project/${projectId}/heat-map`,
                // params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            // providesTags: ["AllActionTracker"],
        }),
        getRiskAgeing: builder.query({
            query: (projectId) => ({
                url: `ProjectRisk/project/${projectId}/risk-ageing`,
                // params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            // providesTags: ["AllActionTracker"],
        }),
        getRiskOverview: builder.query({
            query: (projectId) => ({
                url: `ProjectRisk/project/${projectId}/high-risk-summary`,
                // params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            // providesTags: ["AllActionTracker"],
        }),
        getAverageRiskRating: builder.query({
            query: (projectId) => ({
                url: `ProjectRisk/project/${projectId}/average-risk-rating`,
                // params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            // providesTags: ["AllActionTracker"],
        }),
    }),
});

export const { useLazyGetRiskKpisQuery,
    useLazyGetRiskSeveritySummaryQuery,
    useLazyGetRiskCategorySummaryQuery,
    useLazyGetRiskOwnerSummaryQuery, useLazyGetRiskTrendQuery, useLazyGetRiskHeatMapQuery, useLazyGetRiskAgeingQuery, useLazyGetRiskOverviewQuery, useLazyGetAverageRiskRatingQuery } = riskDashboardSlice;
